<mat-card class="contrast mat-card-inline-sm" [class.card-link]="isSelectable" [class.banner-info]="selectedCard === item?.id" (click)="(isSelectable ? select() : '')">
  <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="5px">
    <div fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
      <div fxLayoutAlign="center start" fxLayout="column" fxLayoutGap="2px">
        <small class="text-info" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
          <span [innerHTML]="item?.title | encodeHtml | highlight: searchTerm"></span>
          <mat-icon class="priority-icon link" [matTooltip]="getPriority(item?.releaseIssuePriority) + ' Priority'" [class.text-danger]="item?.releaseIssuePriority === releaseIssuePriorities.High"
          [class.text-warning]="item?.releaseIssuePriority === releaseIssuePriorities.Medium"
          [class.text-info]="item?.releaseIssuePriority === releaseIssuePriorities.Low"
          (click)="filterByPriority(item?.releaseIssuePriority); $event.stopPropagation();">brightness_1</mat-icon>
          <span *ngIf="item?.releaseIssueCategory">{{ releaseIssueCategories[item?.releaseIssueCategory] }}</span>
        </small>
        <span style="font-size: small;"><i>Affects {{ item?.totalReleaseItems }} release item(s) across {{ item?.totalReleases }} release(s)</i></span>
        <small [innerHTML]="item?.description | encodeHtml | highlight: searchTerm"></small>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <button mat-icon-button *ngIf="item?.reportedSituLink" (click)="openSituLink(item.reportedSituLink); $event.stopPropagation();">
        <mat-icon color="accent" matTooltip="View Issue">preview</mat-icon>
      </button>
      <small (click)="filterByStatus(item?.releaseIssueStatus); $event.stopPropagation();">{{ releaseIssueStatuses[item?.releaseIssueStatus] }}</small>
      <button mat-icon-button (click)="filterByCreated(item?.createdByName); $event.stopPropagation();">
        <mat-icon color="accent" matTooltip="created by {{ item?.createdByName}} {{ item?.dateCreated | date:'short' }}">person</mat-icon>
      </button>
      <ng-container *ngIf="productName !== undefined">
        <button mat-icon-button (click)="loadIssueInViewer(); $event.stopPropagation();" [disabled]="!item?.reportedSituLink">
          <mat-icon color="accent" matTooltip="Load issue in viewer">panorama</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="productName === undefined">
        <button mat-icon-button (click)="filterByAssigned(item?.assignedToName); $event.stopPropagation();">
          <mat-icon [color]="item?.assignedToName ? 'accent' : ''" matTooltip="assigned to {{ item?.assignedToName}}">assignment_ind</mat-icon>
        </button>
        <button *ngIf="!hideEdit" mat-icon-button color="accent" (click)="edit()">
          <mat-icon>edit</mat-icon>
        </button>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>